import { createReducer, on } from '@ngrx/store';
import { environmentActions } from './environment.actions';
import { createInitialServiceVersionsState, EnvironmentState, initialEnvironmentState } from './environment.state';

export const environmentReducer = createReducer(
  initialEnvironmentState,

  on(environmentActions.loadEnvironmentInfo, (state): EnvironmentState => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(environmentActions.loadEnvironmentInfoSuccess, (state, { info }): EnvironmentState => ({
    ...state,
    info,
    loading: false,
    error: null,
  })),

  on(environmentActions.loadEnvironmentInfoError, (state, { error }): EnvironmentState => ({
    ...state,
    loading: false,
    error,
  })),

  on(environmentActions.dismissBanner, (state): EnvironmentState => ({
    ...state,
    bannerDismissed: true,
  })),

  on(environmentActions.showBanner, (state): EnvironmentState => ({
    ...state,
    bannerDismissed: false,
  })),

  on(environmentActions.loadServiceVersions, (state): EnvironmentState => ({
    ...state,
    serviceVersions: state.serviceVersions
      ? { ...state.serviceVersions, loading: true }
      : createInitialServiceVersionsState(true),
  })),

  on(environmentActions.loadServiceVersionsSuccess, (state, { serviceVersions }): EnvironmentState => ({
    ...state,
    serviceVersions: {
      ...serviceVersions,
      loading: false,
    },
  })),

  on(environmentActions.loadServiceVersionsError, (state): EnvironmentState => ({
    ...state,
    serviceVersions: state.serviceVersions
      ? { ...state.serviceVersions, loading: false }
      : null,
  })),
);
